// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { CommercialAgreementOffer } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Offer';
import { UtilityFees } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Types/module';
import { CreateEvent } from '@daml/ledger';
import { Optional } from '@daml/types';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';

export const useCreateCommercialAgreement: () => UseMutationResult<
  CreateEvent<CommercialAgreementOffer>,
  string,
  {
    operator: string;
    user: string;
    feeReceiver: string;
    utilityFees: UtilityFees;
    dso: string;
    rewardReceiver: Optional<string>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['offerCommercialAgreement', ledgerApi],
    mutationFn: async ({ operator, user, feeReceiver, utilityFees, dso, rewardReceiver }) => {
      return ledgerApi.offerCommercialAgreement(
        operator,
        user,
        feeReceiver,
        utilityFees,
        dso,
        null,
        rewardReceiver,
      );
    },
  });
};
